import React, { useEffect } from "react";
import styled from "styled-components";

import ScoreRuleSelectBox from "../Component/ScoreRuleSelectBox";
import ScoreRuleRoundInput from "../Component/ScoreRuleRoundInput";
import ScoreRuleTimeInput from "../Component/ScoreRuleTimeInput";
import ScoreRuleKeywordSelectBox from "../Component/ScoreRuleKeywordSelectBox";
import ScoreRulePrioritySelectBox from "../Component/ScoreRulePrioritySelectBox";
import ScoreRuleCustomTextInput from "../Component/ScorecRuleCustomTextInput";

import WhiteTrashIcon from '../../../Image/WhiteTrashIcon.png';

export default function ScoreRuleSettingBox(props) {
  const {
    isEdit,
    data,
    index,
    size,

    onChangeMainTag,
    onChangeMainIsUseTimeCap,
    onChangeMainRound,
    onChangeMainExerciseMin,
    onChangeMainExerciseSec,
    onChangeMainRestMin,
    onChangeMainRestSec,
    onChangeMainCustomText,
    onChangeMainScoreKeyword,
    onChangeMainScorePriority,
    onChangeIsUseTieBreak,

    onChangeTieBreakTag,
    onChangeTieBreakIsUseTimeCap,
    onChangeTieBreakRound,
    onChangeTieBreakExerciseMin,
    onChangeTieBreakExerciseSec,
    onChangeTieBreakRestMin,
    onChangeTieBreakRestSec,
    onChangeTieBreakCustomText,
    onChangeTieBreakScoreKeyword,
    onChangeTieBreakScorePriority,

    onClickDeleteScoreRule,
    onClickAddScoreRule,
  } = props

  // 컬럼명 정하기 //
  function decideColumnTitle() {
    // return data.viewIndex + '차 기록';
    return (index + 1) + '차 기록';
  }

  // 타이브레이크 컬럼명 정하기 //
  function decideColumnTieBreakTitle() {
    // return data.viewIndex + '차 기록 타이브레이크';
    return (index + 1) + '차 기록 타이브레이크';
  }

  // 메인 EMOM 총 운동 진행시간 표출 //
  function decideEMOMExerciseTime() {
    let round = data.round === '' ? 1 : parseInt(data.round);
    let min = data.exerciseMin === '' ? 0 : parseInt(data.exerciseMin);
    let sec = data.exerciseSec === '' ? 0 : parseInt(data.exerciseSec);
    let time = (min * 60 + sec) * round;
    let finalMin = parseInt(time / 60);
    let finalSec = parseInt(time % 60);

    if (finalMin > 0 && finalSec > 0) return finalMin + '분 ' + finalSec + '초';
    else if (finalMin > 0) return finalMin + ' 분';
    else if (finalSec > 0) return finalSec + ' 초';
    else return '0 분';
  }


  // 메인 TABATA 총 운동 진행시간 표출 //
  function decideTABATAExerciseTime() {
    let round = data.round === '' ? 1 : parseInt(data.round);
    let exerciseMin = data.exerciseMin === '' ? 0 : parseInt(data.exerciseMin);
    let exerciseSec = data.exerciseSec === '' ? 0 : parseInt(data.exerciseSec);
    let restMin = data.restMin === '' ? 0 : parseInt(data.restMin);
    let restSec = data.restSec === '' ? 0 : parseInt(data.restSec);
    let time = ((exerciseMin * 60 + exerciseSec) + (restMin * 60 + restSec)) * round;
    let min = parseInt(time / 60);
    let sec = parseInt(time % 60);

    if (min > 0 && sec > 0) return min + '분 ' + sec + '초';
    else if (min > 0) return min + ' 분';
    else if (sec > 0) return sec + ' 초';
    else return '0 분';
  }

  // 타이브레이크 EMOM 총 운동 진행시간 표출 //
  function decideTieBreakEMOMExerciseTime() {
    let round = data.tieBreakRound === '' ? 1 : parseInt(data.tieBreakRound);
    let min = data.tieBreakExerciseMin === '' ? 0 : parseInt(data.tieBreakExerciseMin);
    let sec = data.tieBreakExerciseSec === '' ? 0 : parseInt(data.tieBreakExerciseSec);
    let time = (min * 60 + sec) * round;
    let finalMin = parseInt(time / 60);
    let finalSec = parseInt(time % 60);

    if (finalMin > 0 && finalSec > 0) return finalMin + '분 ' + finalSec + '초';
    else if (finalMin > 0) return finalMin + ' 분';
    else if (finalSec > 0) return finalSec + ' 초';
    else return '0 분';
  }


  // 타이브레이크 TABATA 총 운동 진행시간 표출 //
  function decideTieBreakTABATAExerciseTime() {
    let round = data.tieBreakRound === '' ? 1 : parseInt(data.tieBreakRound);
    let exerciseMin = data.tieBreakExerciseMin === '' ? 0 : parseInt(data.tieBreakExerciseMin);
    let exerciseSec = data.tieBreakExerciseSec === '' ? 0 : parseInt(data.tieBreakExerciseSec);
    let restMin = data.tieBreakRestMin === '' ? 0 : parseInt(data.tieBreakRestMin);
    let restSec = data.tieBreakRestSec === '' ? 0 : parseInt(data.tieBreakRestSec);
    let time = ((exerciseMin * 60 + exerciseSec) + (restMin * 60 + restSec)) * round;
    let min = parseInt(time / 60);
    let sec = parseInt(time % 60);

    if (min > 0 && sec > 0) return min + '분 ' + sec + '초';
    else if (min > 0) return min + ' 분';
    else if (sec > 0) return sec + ' 초';
    else return '0 분';
  }

  return (
    <TopLevelWrapper>
      <ColumnBoxWrapper>
        <ColumnBox>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>{decideColumnTitle()}</Text>
        </ColumnBox>
        {
          (index !== 0 && isEdit) &&
          <DeleteBox onClick={() => onClickDeleteScoreRule(index)}>
            <DeleteIcon src={WhiteTrashIcon}/>
          </DeleteBox>
        }
      </ColumnBoxWrapper>
      <ViewBox>
        {
          data.tag === 'Custom' &&
          <ComponentWrapper style={{ marginBottom: '20px' }}>
            <ScoreRuleCustomTextInput
              isEdit={isEdit}
              index={index}
              value={data.customText}
              setValue={onChangeMainCustomText}
              placeholder='점수 기록방식을 설명해주세요' />
          </ComponentWrapper>
        }
        <ComponentWrapper>
          <SelectBoxWrapper style={{ zIndex: '100' }}>
            <ScoreRuleSelectBox
              isEdit={isEdit}
              index={index}
              value={data.tag}
              setValue={onChangeMainTag} />
          </SelectBoxWrapper>
        </ComponentWrapper>
        {
          data.tag === 'ForTime' &&
          <ComponentWrapper style={{ marginTop: '20px' }}>
            <DataSettingWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.round} setValue={onChangeMainRound} />
              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <CheckBoxWrapper onClick={() => onChangeMainIsUseTimeCap(!data.isUseTimeCap, index)}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='pointer'>{data.isUseTimeCap ? '시간제한 있음' : '시간제한 없음'}</Text>
                  <CheckBox isClicked={data.isUseTimeCap} />
                </CheckBoxWrapper>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseMin}
                      setValue={onChangeMainExerciseMin}
                      placeholder='0'
                      division='MIN'
                      isUseTimeCap={data.isUseTimeCap} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseSec}
                      setValue={onChangeMainExerciseSec}
                      placeholder='0'
                      division='SEC'
                      isUseTimeCap={data.isUseTimeCap} />
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            </DataSettingWrapper>
          </ComponentWrapper>
        }
        {
          data.tag === 'AMRAP' &&
          <ComponentWrapper style={{ marginTop: '20px' }}>
            <DataSettingWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <ScoreRuleTimeInput
                  isEdit={isEdit}
                  index={index}
                  value={data.exerciseMin}
                  setValue={onChangeMainExerciseMin}
                  placeholder='0'
                  division='MIN'
                  isUseTimeCap={true} />
              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <ScoreRuleTimeInput
                  isEdit={isEdit}
                  index={index}
                  value={data.exerciseSec}
                  setValue={onChangeMainExerciseSec}
                  placeholder='0'
                  division='SEC'
                  isUseTimeCap={true} />
              </ComponentWrapper>
            </DataSettingWrapper>
          </ComponentWrapper>
        }
        {
          data.tag === 'EMOM' &&
          <ComponentWrapper style={{ marginTop: '20px' }}>
            <DataSettingWrapper>
              <ComponentWrapper style={{ width: '46%' }}>

                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                    <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.round} setValue={onChangeMainRound} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <EMOMDivisionLine />
                  </ComponentWrapper>
                </DataSettingWrapper>

              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 별 운동시간</Text>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseMin}
                      setValue={onChangeMainExerciseMin}
                      placeholder='0'
                      division='MIN'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <ComponentTextWrapper style={{ justifyContent: 'flex-start' }}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>총</Text>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#6DD49E' cursor='default'>{decideEMOMExerciseTime()}</Text>
                    </ComponentTextWrapper>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseSec}
                      setValue={onChangeMainExerciseSec}
                      placeholder='0'
                      division='SEC'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            </DataSettingWrapper>
          </ComponentWrapper>
        }
        {
          data.tag === 'TABATA' &&
          <ComponentWrapper style={{ marginTop: '20px' }}>
            <DataSettingWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.round} setValue={onChangeMainRound} />
              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%', marginTop: '36px', flexDirection: 'row', gap: '4px' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>총</Text>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#6DD49E' cursor='default'>{decideTABATAExerciseTime()}</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>동안 진행됩니다</Text>
              </ComponentWrapper>
            </DataSettingWrapper>
            <DataSettingWrapper style={{ marginTop: '10px' }}>
              <ComponentWrapper style={{ width: '46%' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 별 운동시간</Text>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseMin}
                      setValue={onChangeMainExerciseMin}
                      placeholder='0'
                      division='MIN'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.exerciseSec}
                      setValue={onChangeMainExerciseSec}
                      placeholder='0'
                      division='SEC'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.restMin}
                      setValue={onChangeMainRestMin}
                      placeholder='0'
                      division='MIN'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.restSec}
                      setValue={onChangeMainRestSec}
                      placeholder='0'
                      division='SEC'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            </DataSettingWrapper>
          </ComponentWrapper>
        }
        {
          data.tag === 'Custom' &&
          <ComponentWrapper style={{ marginTop: '20px' }}>
            <DataSettingWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>점수 기록 방식</Text>
                <SelectBoxWrapper style={{ zIndex: '90' }}>
                  <ScoreRuleKeywordSelectBox
                    isEdit={isEdit}
                    index={index}
                    value={data.scoreKeyword}
                    setValue={onChangeMainScoreKeyword} />
                </SelectBoxWrapper>
              </ComponentWrapper>
              <ComponentWrapper style={{ width: '46%' }}>
                <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>점수 기록 방식</Text>
                <SelectBoxWrapper style={{ zIndex: '90' }}>
                  <ScoreRulePrioritySelectBox index={index} value={data.scorePriority} setValue={onChangeMainScorePriority} keyword={data.scoreKeyword} />
                </SelectBoxWrapper>
              </ComponentWrapper>
            </DataSettingWrapper>
          </ComponentWrapper>
        }
      </ViewBox>
      <ColumnBoxWrapper>
        <ColumnBox style={{ borderRadius: '0px' }}>
          <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>{decideColumnTieBreakTitle()}</Text>
        </ColumnBox>
        <CheckBoxWrapper onClick={() => onChangeIsUseTieBreak(!data.isUseTieBreak, index)}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='pointer'>{data.isUseTieBreak ? '타이브레이크 있음' : '타이브레이크 없음'}</Text>
          <CheckBox isClicked={data.isUseTieBreak} />
        </CheckBoxWrapper>
      </ColumnBoxWrapper>
      {
        !data.isUseTieBreak ?
          <ViewBox>
            <NoneTieBreakBox>
              <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#747476' cursor='default'>타이브레이크 없음</Text>
            </NoneTieBreakBox>
          </ViewBox>
          :
          <ViewBox>
            {
              data.tieBreakTag === 'Custom' &&
              <ComponentWrapper style={{ marginBottom: '20px' }}>
                <ScoreRuleCustomTextInput
                  isEdit={isEdit}
                  index={index}
                  value={data.tieBreakCustomText}
                  setValue={onChangeTieBreakCustomText}
                  placeholder='점수 기록방식을 설명해주세요' />
              </ComponentWrapper>
            }
            <ComponentWrapper>
              <SelectBoxWrapper style={{ zIndex: '80' }}>
                <ScoreRuleSelectBox
                  isEdit={isEdit}
                  index={index}
                  value={data.tieBreakTag}
                  setValue={onChangeTieBreakTag} />
              </SelectBoxWrapper>
            </ComponentWrapper>
            {
              data.tieBreakTag === 'ForTime' &&
              <ComponentWrapper style={{ marginTop: '20px' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                    <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.tieBreakRound} setValue={onChangeTieBreakRound} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <CheckBoxWrapper onClick={() => onChangeTieBreakIsUseTimeCap(!data.tieBreakIsUseTimeCap, index)}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='pointer'>{data.tieBreakIsUseTimeCap ? '시간제한 있음' : '시간제한 없음'}</Text>
                      <CheckBox isClicked={data.tieBreakIsUseTimeCap} />
                    </CheckBoxWrapper>
                    <DataSettingWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseMin}
                          setValue={onChangeTieBreakExerciseMin}
                          placeholder='0'
                          division='MIN'
                          isUseTimeCap={data.tieBreakIsUseTimeCap} />
                      </ComponentWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseSec}
                          setValue={onChangeTieBreakExerciseSec}
                          placeholder='0'
                          division='SEC'
                          isUseTimeCap={data.tieBreakIsUseTimeCap} />
                      </ComponentWrapper>
                    </DataSettingWrapper>
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            }
            {
              data.tieBreakTag === 'AMRAP' &&
              <ComponentWrapper style={{ marginTop: '20px' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.tieBreakExerciseMin}
                      setValue={onChangeTieBreakExerciseMin}
                      placeholder='0'
                      division='MIN'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <ScoreRuleTimeInput
                      isEdit={isEdit}
                      index={index}
                      value={data.tieBreakExerciseSec}
                      setValue={onChangeTieBreakExerciseSec}
                      placeholder='0'
                      division='SEC'
                      isUseTimeCap={true} />
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            }
            {
              data.tieBreakTag === 'EMOM' &&
              <ComponentWrapper style={{ marginTop: '20px' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <DataSettingWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                        <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.tieBreakRound} setValue={onChangeTieBreakRound} />
                      </ComponentWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <EMOMDivisionLine />
                      </ComponentWrapper>
                    </DataSettingWrapper>

                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <DataSettingWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 별 운동시간</Text>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseMin}
                          setValue={onChangeTieBreakExerciseMin}
                          placeholder='0'
                          division='MIN'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <ComponentTextWrapper style={{ justifyContent: 'flex-start' }}>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>총</Text>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#6DD49E' cursor='default'>{decideTieBreakEMOMExerciseTime()}</Text>
                        </ComponentTextWrapper>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseSec}
                          setValue={onChangeTieBreakExerciseSec}
                          placeholder='0'
                          division='SEC'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                    </DataSettingWrapper>
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            }
            {
              data.tieBreakTag === 'TABATA' &&
              <ComponentWrapper style={{ marginTop: '20px' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드</Text>
                    <ScoreRuleRoundInput isEdit={isEdit} index={index} value={data.tieBreakRound} setValue={onChangeTieBreakRound} />
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%', marginTop: '36px', flexDirection: 'row', gap: '4px' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>총</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#6DD49E' cursor='default'>{decideTieBreakTABATAExerciseTime()}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>동안 진행됩니다</Text>
                  </ComponentWrapper>
                </DataSettingWrapper>
                <DataSettingWrapper style={{ marginTop: '10px' }}>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <DataSettingWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 별 운동시간</Text>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseMin}
                          setValue={onChangeTieBreakExerciseMin}
                          placeholder='0'
                          division='MIN'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakExerciseSec}
                          setValue={onChangeTieBreakExerciseSec}
                          placeholder='0'
                          division='SEC'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                    </DataSettingWrapper>
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <DataSettingWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakRestMin}
                          setValue={onChangeTieBreakRestMin}
                          placeholder='0'
                          division='MIN'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                      <ComponentWrapper style={{ width: '46%' }}>
                        <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>라운드 쉬는 시간</Text>
                        <ScoreRuleTimeInput
                          isEdit={isEdit}
                          index={index}
                          value={data.tieBreakRestSec}
                          setValue={onChangeTieBreakRestSec}
                          placeholder='0'
                          division='SEC'
                          isUseTimeCap={true} />
                      </ComponentWrapper>
                    </DataSettingWrapper>
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            }
            {
              data.tieBreakTag === 'Custom' &&
              <ComponentWrapper style={{ marginTop: '20px' }}>
                <DataSettingWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>점수 기록 방식</Text>
                    <SelectBoxWrapper style={{ zIndex: '70' }}>
                      <ScoreRuleKeywordSelectBox
                        isEdit={isEdit}
                        index={index}
                        value={data.tieBreakScoreKeyword}
                        setValue={onChangeTieBreakScoreKeyword} />
                    </SelectBoxWrapper>
                  </ComponentWrapper>
                  <ComponentWrapper style={{ width: '46%' }}>
                    <Text style={{ opacity: '0' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>점수 기록 방식</Text>
                    <SelectBoxWrapper style={{ zIndex: '70' }}>
                      <ScoreRulePrioritySelectBox index={index} value={data.tieBreakScorePriority} setValue={onChangeTieBreakScorePriority} keyword={data.tieBreakScoreKeyword} />
                    </SelectBoxWrapper>
                  </ComponentWrapper>
                </DataSettingWrapper>
              </ComponentWrapper>
            }
          </ViewBox>
      }
      {
        ((index + 1) === size && size < 3 && isEdit) &&
        <AddColumnBoxWrapper>
          <AddColumnBox onClick={onClickAddScoreRule}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#010101' cursor='pointer'>{size + 1}차 기록 방식</Text>
            <PlusWrapper>
              <PlusStick width={14} height={2} />
              <PlusStick width={2} height={14} />
            </PlusWrapper>
          </AddColumnBox>
        </AddColumnBoxWrapper>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const DeleteBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 60px;
  height: 30px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #D92828;

  :hover {
    cursor: pointer;
  }
`;

const DeleteIcon = styled.img`
  width: 18px;
  height: 18px;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

const NoneTieBreakBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 26px 0px 46px 0px;

  width: 100%;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const SelectBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 36px;
`;

const DataSettingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;

  gap: 5px;
`;

const ComponentTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  
  gap: 4px;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  :hover {
    cursor: pointer;
  }
`;

const CheckBox = styled.div`
  width: 15px;
  height: 15px;

  border: 1px solid ${props => props.isClicked ? `#6CD19C` : `#CBCBCB`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? `#5BD98A` : `#020202`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const EMOMDivisionLine = styled.div`
  margin-top: 42px;

  width: 100%;
  height: 1px;

  border-radius: 5px;
  background-color: #FFFFFF;
`;

const AddColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;
`;

const AddColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  gap: 4px;

  border-radius: 0px 0px 5px 5px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;

  :hover {
    cursor: pointer;
  }
`;

const PlusStick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  background-color: #010101;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
